var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClientFolder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M16.71 13.828a3 3 0 1 0-4.75 0 3.646 3.646 0 0 0-1.258 1.917A1 1 0 0 0 11.668 17a1 1 0 0 0 .966-.743c.2-.74.896-1.257 1.7-1.257.804 0 1.5.517 1.7 1.257a1 1 0 0 0 1.933-.515 3.641 3.641 0 0 0-1.257-1.914ZM14.332 11a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm2-8H9.45L7.282.56A1.667 1.667 0 0 0 6.034 0H1.667A1.667 1.667 0 0 0 0 1.667V14.05a1.617 1.617 0 0 0 1.615 1.616h6.098a1 1 0 0 0 0-2H2V5h14v1.333a1 1 0 0 0 2 0V4.667A1.667 1.667 0 0 0 16.333 3ZM2 3V2h3.884l.89 1H2Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 9,
    x2: 9,
    y1: 0,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.198,
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CA5FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientFolder);
export default __webpack_public_path__ + "static/media/clientFolder.d35f31c621ba9f1aa924caeb7c658f0e.svg";
export { ForwardRef as ReactComponent };